<template>
  <div id="app">
    <!-- <PreLoader /> -->
    <NavBar />
     <transition name="fade" >
      <router-view/>
     </transition>
   
   
    <PageFlight />
   
    
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'
import PageFlight from "./components/PageFlight";
export default {
  components: {
    NavBar,
    PageFlight
   
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.fade-enter {
  opacity: 0;
}

.fade-enter-active{
  transition: all 1s ease;
}

/* .fade-leave-to {
  opacity: 0;
} */

</style>
